var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IFrame_1;
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { intellisense, IntellisenseExpectedType, listOf, object, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues, getResolvedPathAndParameters, isPathReady } from '@philips-internal/oswald-ui-utils';
import IFrameAPI from './iframe-api.js';
import { IFrameAllowOptions, IFrameSandboxOptions } from './iframe-constants.js';
// These policies are considered best pratices to have a good experiences
// on the web, when using iframes, and should be enforced when possible.
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Feature_Policy/Using_Feature_Policy#enforcing_best_practices_for_good_user_experiences
const fixedAllowPolicies = [
    `layout-animations 'none'`,
    `oversized-images 'none'`,
    `sync-script 'none'`,
    `sync-xhr 'none'`,
    `unoptimized-images 'none'`,
    `unsized-media 'none'`,
];
let IFrame = IFrame_1 = class IFrame extends PureComponent {
    buildUrlProperty() {
        const { endpoint, data = IFrame_1.defaultProps.data } = this.props;
        if (!endpoint) {
            return null;
        }
        const { resolvedPath } = getResolvedPathAndParameters(endpoint, data);
        if (isPathReady(resolvedPath)) {
            return resolvedPath;
        }
        return null;
    }
    buildSandboxProperty() {
        const { sandboxOptions = IFrame_1.defaultProps.sandboxOptions } = this.props;
        // In order to keep the iframe as secure as possible, we apply all restrictions and
        // allow the user to add the necessary permissions for the use case one by one.
        // If no permissions are set, this join will return an empty string '', keeping the
        // iframe with all restrictions
        return sandboxOptions.join(' ');
    }
    buildAllowProperty() {
        const { allowOptions = IFrame_1.defaultProps.allowOptions } = this.props;
        return [...fixedAllowPolicies, ...allowOptions].join('; ');
    }
    render() {
        const { height, id, width } = this.props;
        const allow = this.buildAllowProperty();
        const endpoint = this.buildUrlProperty();
        const sandbox = this.buildSandboxProperty();
        if (!endpoint) {
            return null;
        }
        return (React.createElement("iframe", { allow: allow, frameBorder: "0", height: height, id: id, name: id, sandbox: sandbox, src: endpoint, style: { border: 0 }, width: width }));
    }
};
IFrame.propTypes = {
    allowOptions: listOf(oneOf(enumValues(IFrameAllowOptions))).group('allow'),
    data: object.notEnumerable(),
    endpoint: intellisense(string, IntellisenseExpectedType.URL),
    height: string,
    id: string,
    sandboxOptions: listOf(oneOf(enumValues(IFrameSandboxOptions))).group('sandbox'),
    width: string,
};
IFrame.defaultProps = {
    allowOptions: [],
    data: {},
    height: '100%',
    sandboxOptions: [],
    width: '100%',
};
IFrame = IFrame_1 = __decorate([
    AwesomeComponent({ api: IFrameAPI, type: ComponentType.DATA_DISPLAY })
], IFrame);
export default IFrame;
//# sourceMappingURL=iframe.js.map